<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(submit)">
          <md-card>
            <md-card-header class="md-card-header-text md-card-header-green">
              <div class="card-text">
                <h4 class="title">{{ formTitle }}</h4>
              </div>
            </md-card-header>

            <div class="management-uni-rating-container">
              <router-link
                data-toggle="dropdown"
                class="edit-btn"
                v-if="id"
                :to="{ name: 'ManageProgramRatings', params: { id: id } }"
              >
                <p class="content-button">
                  {{ $t("program.manage_score") }}
                </p>
              </router-link>
            </div>

            <md-card-content>
              <div class="md-layout text-center">
                <div class="md-layout-item md-size-100 md-xsmall-size-100">
                  <div class="md-layout">
                    <!-- Avatar and cover img  -->
                    <div class="md-layout-item md-size-100 md-xsmall-size-100">
                      <div class="md-layout">
                        <!-- Avatar -->
                        <div
                          class="md-layout-item md-size-50 md-xsmall-size-100"
                          id="uni-avatar"
                        >
                          <h4 class="card-title">
                            {{ $t("university.avatar") }}
                          </h4>
                          <div class="file-input img-circle">
                            <template v-if="!imageCircle">
                              <div class="image-fix-container">
                                <img :src="avatarImg" title="" alt="" />
                              </div>
                            </template>
                            <div class="image-fix-container" v-else>
                              <img :src="imageCircle" alt="" />
                            </div>
                            <div class="button-container">
                              <md-button
                                class="md-success md-round md-fileinput"
                                @click="onFileChange"
                              >
                                <template v-if="!imageCircle"
                                  >{{ $t("user.add_avatar") }}
                                </template>
                                <template v-else
                                  >{{ $t("user.change_avatar") }}
                                </template>
                              </md-button>
                            </div>
                          </div>
                        </div>

                        <!-- Cover -->
                        <div
                          class="md-layout-item md-size-50 md-xsmall-size-100"
                          id="uni-cover"
                        >
                          <h4 class="card-title">
                            {{ $t("university.cover_image") }}
                          </h4>
                          <div class="file-input img-circle">
                            <template v-if="!coverImageCircle">
                              <div class="image-fix-container">
                                <img :src="avatarImg" title="" alt="" />
                              </div>
                            </template>
                            <div class="image-fix-container" v-else>
                              <img :src="coverImageCircle" alt="" />
                            </div>
                            <div class="button-container">
                              <md-button
                                class="md-success md-round md-fileinput"
                                @click="onFileChangeCover"
                              >
                                <template v-if="!coverImageCircle"
                                  >{{ $t("university.add_cover_image") }}
                                </template>
                                <template v-else
                                  >{{ $t("university.change_cover_image") }}
                                </template>
                              </md-button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Left  -->
                    <div class="md-layout-item md-size-50 md-xsmall-size-100">
                      <div class="md-layout">
                        <!-- Name program  -->
                        <div
                          class="md-layout-item md-size-100 md-xsmall-size-100"
                        >
                          <div class="uni-count-container">
                            <h4 class="text-align-left">
                              {{ $t("program.program_name_title") }}
                            </h4>
                          </div>
                        </div>

                        <!--   Name    -->
                        <div
                          class="md-layout-item md-size-100 md-xsmall-size-100"
                        >
                          <div class="md-layout">
                            <label
                              class="md-layout-item md-size-20 md-xsmall-size-100  md-form-label required-field"
                              :for="$t('program.name')"
                            >
                              {{ $t("program.name") }}
                            </label>
                            <div class="md-layout-item md-xsmall-size-100">
                              <ValidationProvider
                                :name="$t('program.name')"
                                rules="required"
                                v-slot="{ passed, failed, errors }"
                              >
                                <md-field
                                  :class="[
                                    { 'md-error': failed },
                                    { 'md-valid': passed }
                                  ]"
                                >
                                  <md-input v-model="params.name" type="text">
                                  </md-input>

                                  <slide-y-down-transition>
                                    <md-icon class="error" v-show="failed"
                                      >close
                                    </md-icon>
                                  </slide-y-down-transition>
                                  <slide-y-down-transition>
                                    <md-icon class="success" v-show="passed"
                                      >done
                                    </md-icon>
                                  </slide-y-down-transition>
                                </md-field>
                                <div class="validate-error">
                                  {{ errors[0] }}
                                </div>
                              </ValidationProvider>
                            </div>
                          </div>
                        </div>

                        <!--   vi_name    -->
                        <div
                          class="md-layout-item md-size-100 md-xsmall-size-100"
                        >
                          <div class="md-layout">
                            <label
                              class="md-layout-item md-size-20 md-xsmall-size-100  md-form-label required-field"
                              :for="$t('program.vi_name')"
                            >
                              {{ $t("program.vi_name") }}
                            </label>
                            <div
                              class="md-layout-item md-size-80 md-xsmall-size-100"
                            >
                              <ValidationProvider
                                :name="$t('program.vi_name')"
                                rules="required"
                                v-slot="{ passed, failed, errors }"
                              >
                                <md-field
                                  :class="[
                                    { 'md-error': failed },
                                    { 'md-valid': passed }
                                  ]"
                                >
                                  <md-input
                                    v-model="params.vi_name"
                                    type="text"
                                  >
                                  </md-input>

                                  <slide-y-down-transition>
                                    <md-icon class="error" v-show="failed"
                                      >close
                                    </md-icon>
                                  </slide-y-down-transition>
                                  <slide-y-down-transition>
                                    <md-icon class="success" v-show="passed"
                                      >done
                                    </md-icon>
                                  </slide-y-down-transition>
                                </md-field>
                                <div class="validate-error">
                                  {{ errors[0] }}
                                </div>
                              </ValidationProvider>
                            </div>
                          </div>
                        </div>

                        <!--   program_division    -->
                        <div
                          class="md-layout-item md-size-100 md-xsmall-size-100"
                        >
                          <div class="md-layout">
                            <label
                              class="md-layout-item md-size-20 md-xsmall-size-100  md-form-label required-field"
                              :for="$t('program.program_division_name')"
                            >
                              {{ $t("program.program_division_name") }}
                            </label>
                            <div
                              class="md-layout-item md-size-80 md-xsmall-size-100"
                            >
                              <ValidationProvider
                                :name="$t('program.program_division_name')"
                                rules="required"
                                v-slot="{ passed, failed, errors }"
                              >
                                <md-field
                                  :class="[
                                    { 'md-error': failed },
                                    { 'md-valid': passed }
                                  ]"
                                >
                                  <md-select
                                    v-model="params.program_division_id"
                                    :name="$t('program.program_type_name')"
                                  >
                                    <md-option
                                      :value="option.id"
                                      v-for="option in programDivisionOptions"
                                      :key="option.id"
                                      >{{ option.name }}
                                    </md-option>
                                  </md-select>

                                  <slide-y-down-transition>
                                    <md-icon class="error" v-show="failed"
                                      >close
                                    </md-icon>
                                  </slide-y-down-transition>
                                  <slide-y-down-transition>
                                    <md-icon class="success" v-show="passed"
                                      >done
                                    </md-icon>
                                  </slide-y-down-transition>
                                </md-field>
                                <div class="validate-error">
                                  {{ errors[0] }}
                                </div>
                              </ValidationProvider>
                            </div>
                          </div>
                        </div>

                        <!--   program_type    -->
                        <div
                          class="md-layout-item md-size-100 md-xsmall-size-100"
                        >
                          <div class="md-layout">
                            <label
                              class="md-layout-item md-size-20 md-xsmall-size-100  md-form-label required-field"
                              :for="$t('program.program_type_name')"
                            >
                              {{ $t("program.program_type_name") }}
                            </label>
                            <div
                              class="md-layout-item md-size-80 md-xsmall-size-100"
                            >
                              <ValidationProvider
                                :name="$t('program.program_type_name')"
                                rules="required"
                                v-slot="{ passed, failed, errors }"
                              >
                                <md-field
                                  :class="[
                                    { 'md-error': failed },
                                    { 'md-valid': passed }
                                  ]"
                                >
                                  <md-select
                                    v-model="params.program_type_id"
                                    :name="$t('program.program_type_name')"
                                  >
                                    <md-option
                                      :value="option.id"
                                      v-for="option in programTypeOptions"
                                      :key="option.id"
                                      >{{ option.name }}
                                    </md-option>
                                  </md-select>

                                  <slide-y-down-transition>
                                    <md-icon class="error" v-show="failed"
                                      >close
                                    </md-icon>
                                  </slide-y-down-transition>
                                  <slide-y-down-transition>
                                    <md-icon class="success" v-show="passed"
                                      >done
                                    </md-icon>
                                  </slide-y-down-transition>
                                </md-field>
                                <div class="validate-error">
                                  {{ errors[0] }}
                                </div>
                              </ValidationProvider>
                            </div>
                          </div>
                        </div>

                        <div
                          class="md-layout-item md-size-100 md-xsmall-size-100"
                        >
                          <md-divider
                            style="    margin: 20px 0px 10px; background: none;"
                          ></md-divider>
                        </div>
                        <!-- END Name program  -->

                        <!--  university Info -->
                        <div
                          class="md-layout-item md-size-100 md-xsmall-size-100"
                        >
                          <div class="uni-count-container">
                            <h4 class="text-align-left">
                              {{ $t("program.university_name_title") }}
                            </h4>
                          </div>
                        </div>

                        <!--   Name    -->
                        <div
                          class="md-layout-item md-size-100 md-xsmall-size-100"
                        >
                          <div class="md-layout">
                            <label
                              class="md-layout-item md-size-20 md-xsmall-size-100  md-form-label required-field"
                              :for="$t('program.university_name')"
                            >
                              {{ $t("program.university_name") }}
                            </label>
                            <div class="md-layout-item md-xsmall-size-100">
                              <ValidationProvider
                                :name="$t('program.university_name')"
                                rules="required"
                                v-slot="{ passed, failed, errors }"
                              >
                                <md-field
                                  :class="[
                                    { 'md-error': failed },
                                    { 'md-valid': passed }
                                  ]"
                                >
                                  <md-input
                                    v-model="params.university_name"
                                    type="text"
                                  >
                                  </md-input>

                                  <slide-y-down-transition>
                                    <md-icon class="error" v-show="failed"
                                      >close
                                    </md-icon>
                                  </slide-y-down-transition>
                                  <slide-y-down-transition>
                                    <md-icon class="success" v-show="passed"
                                      >done
                                    </md-icon>
                                  </slide-y-down-transition>
                                </md-field>
                                <div class="validate-error">
                                  {{ errors[0] }}
                                </div>
                              </ValidationProvider>
                            </div>
                          </div>
                        </div>

                        <!--   vi_name    -->
                        <div
                          class="md-layout-item md-size-100 md-xsmall-size-100"
                        >
                          <div class="md-layout">
                            <label
                              class="md-layout-item md-size-20 md-xsmall-size-100  md-form-label required-field"
                              :for="$t('program.university_vi_name')"
                            >
                              {{ $t("program.university_vi_name") }}
                            </label>
                            <div
                              class="md-layout-item md-size-80 md-xsmall-size-100"
                            >
                              <ValidationProvider
                                :name="$t('program.university_vi_name')"
                                rules="required"
                                v-slot="{ passed, failed, errors }"
                              >
                                <md-field
                                  :class="[
                                    { 'md-error': failed },
                                    { 'md-valid': passed }
                                  ]"
                                >
                                  <md-input
                                    v-model="params.university_vi_name"
                                    type="text"
                                  >
                                  </md-input>

                                  <slide-y-down-transition>
                                    <md-icon class="error" v-show="failed"
                                      >close
                                    </md-icon>
                                  </slide-y-down-transition>
                                  <slide-y-down-transition>
                                    <md-icon class="success" v-show="passed"
                                      >done
                                    </md-icon>
                                  </slide-y-down-transition>
                                </md-field>
                                <div class="validate-error">
                                  {{ errors[0] }}
                                </div>
                              </ValidationProvider>
                            </div>
                          </div>
                        </div>

                        <!--   nation    -->
                        <div
                          class="md-layout-item md-size-100 md-xsmall-size-100"
                        >
                          <div class="md-layout">
                            <label
                              class="md-layout-item md-size-20 md-xsmall-size-100  md-form-label required-field"
                              :for="$t('program.nation')"
                            >
                              {{ $t("program.nation") }}
                            </label>
                            <div
                              class="md-layout-item md-size-80 md-xsmall-size-100"
                            >
                              <ValidationProvider
                                :name="$t('program.nation')"
                                rules="required"
                                v-slot="{ passed, failed, errors }"
                              >
                                <md-field
                                  :class="[
                                    { 'md-error': failed },
                                    { 'md-valid': passed }
                                  ]"
                                >
                                  <div class="form-select2-container">
                                    <select2
                                      v-model="params.country_alpha_two_code"
                                      :name="$t('program.nation')"
                                      :options="nationOptions"
                                      :settings="{
                                        dropdownAutoWidth: true,
                                        width: 'inherit'
                                      }"
                                    />
                                  </div>

                                  <slide-y-down-transition>
                                    <md-icon class="error" v-show="failed"
                                      >close
                                    </md-icon>
                                  </slide-y-down-transition>
                                  <slide-y-down-transition>
                                    <md-icon class="success" v-show="passed"
                                      >done
                                    </md-icon>
                                  </slide-y-down-transition>
                                </md-field>
                                <div class="validate-error">
                                  {{ errors[0] }}
                                </div>
                              </ValidationProvider>
                            </div>
                          </div>
                        </div>

                        <!--   university_address    -->
                        <div
                          class="md-layout-item md-size-100 md-xsmall-size-100"
                        >
                          <div class="md-layout">
                            <label
                              class="md-layout-item md-size-20 md-xsmall-size-100  md-form-label required-field"
                              :for="$t('program.university_address')"
                            >
                              {{ $t("program.university_address") }}
                            </label>
                            <div
                              class="md-layout-item md-size-80 md-xsmall-size-100"
                            >
                              <ValidationProvider
                                :name="$t('program.university_address')"
                                rules="required"
                                v-slot="{ passed, failed, errors }"
                              >
                                <md-field
                                  :class="[
                                    { 'md-error': failed },
                                    { 'md-valid': passed }
                                  ]"
                                >
                                  <md-input
                                    v-model="params.university_address"
                                    type="text"
                                  >
                                  </md-input>

                                  <slide-y-down-transition>
                                    <md-icon class="error" v-show="failed"
                                      >close
                                    </md-icon>
                                  </slide-y-down-transition>
                                  <slide-y-down-transition>
                                    <md-icon class="success" v-show="passed"
                                      >done
                                    </md-icon>
                                  </slide-y-down-transition>
                                </md-field>
                                <div class="validate-error">
                                  {{ errors[0] }}
                                </div>
                              </ValidationProvider>
                            </div>
                          </div>
                        </div>

                        <div
                          class="md-layout-item md-size-100 md-xsmall-size-100"
                        >
                          <md-divider
                            style="    margin: 20px 0px 10px; background: none;"
                          ></md-divider>
                        </div>
                        <!-- END university Info  -->
                      </div>
                    </div>

                    <!--  Right  -->
                    <div class="md-layout-item md-size-50 md-xsmall-size-100">
                      <div class="md-layout">
                        <!--  Faculty of Management -->
                        <div
                          class="md-layout-item md-size-100 md-xsmall-size-100"
                        >
                          <div class="uni-count-container">
                            <h4 class="text-align-left">
                              {{ $t("program.faculty_name_title") }}
                            </h4>
                          </div>
                        </div>

                        <!--   Faculty Name    -->
                        <div
                          class="md-layout-item md-size-100 md-xsmall-size-100"
                        >
                          <div class="md-layout">
                            <label
                              class="md-layout-item md-size-20 md-xsmall-size-100  md-form-label required-field"
                              :for="$t('program.faculty_name')"
                            >
                              {{ $t("program.faculty_name") }}
                            </label>
                            <div class="md-layout-item md-xsmall-size-100">
                              <ValidationProvider
                                :name="$t('program.faculty_name')"
                                rules="required"
                                v-slot="{ passed, failed, errors }"
                              >
                                <md-field
                                  :class="[
                                    { 'md-error': failed },
                                    { 'md-valid': passed }
                                  ]"
                                >
                                  <md-input
                                    v-model="params.faculty_name"
                                    type="text"
                                  >
                                  </md-input>

                                  <slide-y-down-transition>
                                    <md-icon class="error" v-show="failed"
                                      >close
                                    </md-icon>
                                  </slide-y-down-transition>
                                  <slide-y-down-transition>
                                    <md-icon class="success" v-show="passed"
                                      >done
                                    </md-icon>
                                  </slide-y-down-transition>
                                </md-field>
                                <div class="validate-error">
                                  {{ errors[0] }}
                                </div>
                              </ValidationProvider>
                            </div>
                          </div>
                        </div>

                        <!--   Faculty vi_name    -->
                        <div
                          class="md-layout-item md-size-100 md-xsmall-size-100"
                        >
                          <div class="md-layout">
                            <label
                              class="md-layout-item md-size-20 md-xsmall-size-100  md-form-label required-field"
                              :for="$t('program.faculty_vi_name')"
                            >
                              {{ $t("program.faculty_vi_name") }}
                            </label>
                            <div
                              class="md-layout-item md-size-80 md-xsmall-size-100"
                            >
                              <ValidationProvider
                                :name="$t('program.faculty_vi_name')"
                                rules="required"
                                v-slot="{ passed, failed, errors }"
                              >
                                <md-field
                                  :class="[
                                    { 'md-error': failed },
                                    { 'md-valid': passed }
                                  ]"
                                >
                                  <md-input
                                    v-model="params.faculty_vi_name"
                                    type="text"
                                  >
                                  </md-input>

                                  <slide-y-down-transition>
                                    <md-icon class="error" v-show="failed"
                                      >close
                                    </md-icon>
                                  </slide-y-down-transition>
                                  <slide-y-down-transition>
                                    <md-icon class="success" v-show="passed"
                                      >done
                                    </md-icon>
                                  </slide-y-down-transition>
                                </md-field>
                                <div class="validate-error">
                                  {{ errors[0] }}
                                </div>
                              </ValidationProvider>
                            </div>
                          </div>
                        </div>

                        <!--   staff_full_time    -->
                        <div
                          class="md-layout-item md-size-50 md-xsmall-size-100"
                        >
                          <div class="md-layout">
                            <label
                              class="md-layout-item md-size-50 md-xsmall-size-100  md-form-label required-field"
                              :for="$t('program.staff_full_time')"
                            >
                              {{ $t("program.staff_full_time") }}
                            </label>
                            <div
                              class="md-layout-item md-size-50 md-xsmall-size-100"
                            >
                              <ValidationProvider
                                :name="$t('program.staff_full_time')"
                                rules="required|numeric"
                                v-slot="{ passed, failed, errors }"
                              >
                                <md-field
                                  :class="[
                                    { 'md-error': failed },
                                    { 'md-valid': passed }
                                  ]"
                                >
                                  <md-input
                                    v-model="params.staff_full_time"
                                    type="number"
                                    min="0"
                                  >
                                  </md-input>

                                  <slide-y-down-transition>
                                    <md-icon class="error" v-show="failed"
                                      >close
                                    </md-icon>
                                  </slide-y-down-transition>
                                  <slide-y-down-transition>
                                    <md-icon class="success" v-show="passed"
                                      >done
                                    </md-icon>
                                  </slide-y-down-transition>
                                </md-field>
                                <div class="validate-error">
                                  {{ errors[0] }}
                                </div>
                              </ValidationProvider>
                            </div>
                          </div>
                        </div>

                        <!--   staff_part_time    -->
                        <div
                          class="md-layout-item md-size-50 md-xsmall-size-100"
                        >
                          <div class="md-layout">
                            <label
                              class="md-layout-item md-size-50 md-xsmall-size-100  md-form-label required-field"
                              :for="$t('program.staff_part_time')"
                            >
                              {{ $t("program.staff_part_time") }}
                            </label>
                            <div
                              class="md-layout-item md-size-50 md-xsmall-size-100"
                            >
                              <ValidationProvider
                                :name="$t('program.staff_part_time')"
                                rules="required|numeric"
                                v-slot="{ passed, failed, errors }"
                              >
                                <md-field
                                  :class="[
                                    { 'md-error': failed },
                                    { 'md-valid': passed }
                                  ]"
                                >
                                  <md-input
                                    v-model="params.staff_part_time"
                                    type="number"
                                    min="0"
                                  >
                                  </md-input>

                                  <slide-y-down-transition>
                                    <md-icon class="error" v-show="failed"
                                      >close
                                    </md-icon>
                                  </slide-y-down-transition>
                                  <slide-y-down-transition>
                                    <md-icon class="success" v-show="passed"
                                      >done
                                    </md-icon>
                                  </slide-y-down-transition>
                                </md-field>
                                <div class="validate-error">
                                  {{ errors[0] }}
                                </div>
                              </ValidationProvider>
                            </div>
                          </div>
                        </div>

                        <!--   master_percent    -->
                        <div
                          class="md-layout-item md-size-50 md-xsmall-size-100"
                        >
                          <div class="md-layout">
                            <label
                              class="md-layout-item md-size-50 md-xsmall-size-100  md-form-label required-field"
                              :for="$t('program.master_percent')"
                            >
                              {{ $t("program.master_percent") }}
                            </label>
                            <div
                              class="md-layout-item md-size-50 md-xsmall-size-100"
                            >
                              <ValidationProvider
                                :name="$t('program.master_percent')"
                                rules="required|numeric"
                                v-slot="{ passed, failed, errors }"
                              >
                                <md-field
                                  :class="[
                                    { 'md-error': failed },
                                    { 'md-valid': passed }
                                  ]"
                                >
                                  <md-input
                                    v-model="params.master_percent"
                                    type="number"
                                    min="0"
                                  >
                                  </md-input>

                                  <slide-y-down-transition>
                                    <md-icon class="error" v-show="failed"
                                      >close
                                    </md-icon>
                                  </slide-y-down-transition>
                                  <slide-y-down-transition>
                                    <md-icon class="success" v-show="passed"
                                      >done
                                    </md-icon>
                                  </slide-y-down-transition>
                                </md-field>
                                <div class="validate-error">
                                  {{ errors[0] }}
                                </div>
                              </ValidationProvider>
                            </div>
                          </div>
                        </div>

                        <!--   doctoral_percent    -->
                        <div
                          class="md-layout-item md-size-50 md-xsmall-size-100"
                        >
                          <div class="md-layout">
                            <label
                              class="md-layout-item md-size-50 md-xsmall-size-100  md-form-label required-field"
                              :for="$t('program.doctoral_percent')"
                            >
                              {{ $t("program.doctoral_percent") }}
                            </label>
                            <div
                              class="md-layout-item md-size-50 md-xsmall-size-100"
                            >
                              <ValidationProvider
                                :name="$t('program.doctoral_percent')"
                                rules="required|numeric"
                                v-slot="{ passed, failed, errors }"
                              >
                                <md-field
                                  :class="[
                                    { 'md-error': failed },
                                    { 'md-valid': passed }
                                  ]"
                                >
                                  <md-input
                                    v-model="params.doctoral_percent"
                                    type="number"
                                    min="0"
                                  >
                                  </md-input>

                                  <slide-y-down-transition>
                                    <md-icon class="error" v-show="failed"
                                      >close
                                    </md-icon>
                                  </slide-y-down-transition>
                                  <slide-y-down-transition>
                                    <md-icon class="success" v-show="passed"
                                      >done
                                    </md-icon>
                                  </slide-y-down-transition>
                                </md-field>
                                <div class="validate-error">
                                  {{ errors[0] }}
                                </div>
                              </ValidationProvider>
                            </div>
                          </div>
                        </div>

                        <!--   faculty_scale    -->
                        <div
                          class="md-layout-item md-size-50 md-xsmall-size-100"
                        >
                          <div class="md-layout">
                            <label
                              class="md-layout-item md-size-50 md-xsmall-size-100  md-form-label required-field"
                              :for="$t('program.faculty_scale')"
                            >
                              {{ $t("program.faculty_scale") }}
                            </label>
                            <div
                              class="md-layout-item md-size-50 md-xsmall-size-100"
                            >
                              <ValidationProvider
                                :name="$t('program.faculty_scale')"
                                rules="required|numeric"
                                v-slot="{ passed, failed, errors }"
                              >
                                <md-field
                                  :class="[
                                    { 'md-error': failed },
                                    { 'md-valid': passed }
                                  ]"
                                >
                                  <md-input
                                    v-model="params.faculty_scale"
                                    type="number"
                                    min="0"
                                  >
                                  </md-input>

                                  <slide-y-down-transition>
                                    <md-icon class="error" v-show="failed"
                                      >close
                                    </md-icon>
                                  </slide-y-down-transition>
                                  <slide-y-down-transition>
                                    <md-icon class="success" v-show="passed"
                                      >done
                                    </md-icon>
                                  </slide-y-down-transition>
                                </md-field>
                                <div class="validate-error">
                                  {{ errors[0] }}
                                </div>
                              </ValidationProvider>
                            </div>
                          </div>
                        </div>

                        <!--   program_scale    -->
                        <div
                          class="md-layout-item md-size-50 md-xsmall-size-100"
                        >
                          <div class="md-layout">
                            <label
                              class="md-layout-item md-size-50 md-xsmall-size-100  md-form-label required-field"
                              :for="$t('program.program_scale')"
                            >
                              {{ $t("program.program_scale") }}
                            </label>
                            <div
                              class="md-layout-item md-size-50 md-xsmall-size-100"
                            >
                              <ValidationProvider
                                :name="$t('program.program_scale')"
                                rules="required|numeric"
                                v-slot="{ passed, failed, errors }"
                              >
                                <md-field
                                  :class="[
                                    { 'md-error': failed },
                                    { 'md-valid': passed }
                                  ]"
                                >
                                  <md-input
                                    v-model="params.program_scale"
                                    type="number"
                                    min="0"
                                  >
                                  </md-input>

                                  <slide-y-down-transition>
                                    <md-icon class="error" v-show="failed"
                                      >close
                                    </md-icon>
                                  </slide-y-down-transition>
                                  <slide-y-down-transition>
                                    <md-icon class="success" v-show="passed"
                                      >done
                                    </md-icon>
                                  </slide-y-down-transition>
                                </md-field>
                                <div class="validate-error">
                                  {{ errors[0] }}
                                </div>
                              </ValidationProvider>
                            </div>
                          </div>
                        </div>
                        <div
                          class="md-layout-item md-size-100 md-xsmall-size-100"
                        >
                          <md-divider
                            style="    margin: 20px 0px 10px; background: none;"
                          ></md-divider>
                        </div>
                        <!-- END Faculty of Management  -->
                      </div>
                    </div>

                    <div class="md-layout-item md-size-50 md-xsmall-size-100">
                      <div class="md-layout">
                        <!--  Introduce general program -->
                        <div
                          class="md-layout-item md-size-100 md-xsmall-size-100"
                        >
                          <div class="uni-count-container">
                            <h4 class="text-align-left">
                              {{ $t("program.program_introduce") }}
                            </h4>
                          </div>
                        </div>

                        <!--   video    -->
                        <div
                          class="md-layout-item md-size-100 md-xsmall-size-100"
                        >
                          <div class="md-layout">
                            <label
                              class="md-layout-item md-size-20 md-xsmall-size-100  md-form-label"
                              :for="$t('program.video')"
                            >
                              {{ $t("program.video") }}
                            </label>
                            <div
                              class="md-layout-item md-size-80 md-xsmall-size-100"
                            >
                              <ValidationProvider
                                :name="$t('program.video')"
                                rules="validUrl"
                                v-slot="{ passed, failed, errors }"
                              >
                                <md-field
                                  :class="[
                                    { 'md-error': failed },
                                    { 'md-valid': passed }
                                  ]"
                                >
                                  <!--                                  <md-file-->
                                  <!--                                    @md-change="changeVideo"-->
                                  <!--                                    accept="video/*"-->
                                  <!--                                    v-model="video"-->
                                  <!--                                  >-->
                                  <!--                                  </md-file>-->
                                  <md-input
                                    v-model="params.video"
                                    type="text"
                                  />
                                  <slide-y-down-transition>
                                    <md-icon class="error" v-show="failed"
                                      >close
                                    </md-icon>
                                  </slide-y-down-transition>
                                  <slide-y-down-transition>
                                    <md-icon class="success" v-show="passed"
                                      >done
                                    </md-icon>
                                  </slide-y-down-transition>
                                </md-field>
                                <div class="validate-error">
                                  {{ errors[0] }}
                                </div>
                              </ValidationProvider>
                            </div>
                          </div>
                        </div>

                        <!--                        &lt;!&ndash;   url    &ndash;&gt;-->
                        <!--                        <div-->
                        <!--                          class="md-layout-item md-size-100 md-xsmall-size-100"-->
                        <!--                        >-->
                        <!--                          <div class="md-layout">-->
                        <!--                            <label-->
                        <!--                              class="md-layout-item md-size-20 md-xsmall-size-100  md-form-label"-->
                        <!--                              :for="$t('program.url')"-->
                        <!--                            >-->
                        <!--                              {{ $t("program.url") }}-->
                        <!--                            </label>-->
                        <!--                            <div-->
                        <!--                              class="md-layout-item md-size-80 md-xsmall-size-100"-->
                        <!--                            >-->
                        <!--                              <ValidationProvider-->
                        <!--                                :name="$t('program.url')"-->
                        <!--                                rules=""-->
                        <!--                                v-slot="{ passed, failed, errors }"-->
                        <!--                              >-->
                        <!--                                <md-field-->
                        <!--                                  :class="[-->
                        <!--                                    { 'md-error': failed },-->
                        <!--                                    { 'md-valid': passed }-->
                        <!--                                  ]"-->
                        <!--                                >-->
                        <!--                                  <md-input v-model="params.url" type="text">-->
                        <!--                                  </md-input>-->

                        <!--                                  <slide-y-down-transition>-->
                        <!--                                    <md-icon class="error" v-show="failed"-->
                        <!--                                      >close-->
                        <!--                                    </md-icon>-->
                        <!--                                  </slide-y-down-transition>-->
                        <!--                                  <slide-y-down-transition>-->
                        <!--                                    <md-icon class="success" v-show="passed"-->
                        <!--                                      >done-->
                        <!--                                    </md-icon>-->
                        <!--                                  </slide-y-down-transition>-->
                        <!--                                </md-field>-->
                        <!--                                <div class="validate-error">-->
                        <!--                                  {{ errors[0] }}-->
                        <!--                                </div>-->
                        <!--                              </ValidationProvider>-->
                        <!--                            </div>-->
                        <!--                          </div>-->
                        <!--                        </div>-->

                        <!--   is_public    -->
                        <div
                          class="md-layout-item md-size-100 md-xsmall-size-100 text-align-left"
                        >
                          <div class="md-layout">
                            <div
                              class="md-layout-item md-size-20 md-xsmall-size-100"
                            ></div>
                            <div
                              class="md-layout-item md-size-80 md-xsmall-size-100"
                            >
                              <ValidationProvider
                                :name="$t('program.is_public')"
                                rules=""
                                v-slot="{ passed, failed, errors }"
                              >
                                <md-checkbox v-model="params.is_public">
                                  {{ $t("program.is_public") }}
                                </md-checkbox>
                                <div class="validate-error">
                                  {{ errors[0] }}
                                </div>
                              </ValidationProvider>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Introduction  -->
                    <div class="md-layout-item md-size-100 md-xsmall-size-100">
                      <div class="md-layout">
                        <label
                          class="md-layout-item md-size-10 md-xsmall-size-100  md-form-label required-field"
                          :for="$t('program.introduction')"
                          style="padding-left: 10px;"
                        >
                          {{ $t("program.introduction") }}
                        </label>
                        <div
                          class="md-layout-item md-size-90 md-xsmall-size-100"
                        >
                          <ValidationProvider
                            :name="$t('program.introduction')"
                            rules="required"
                            v-slot="{ passed, failed, errors }"
                          >
                            <md-field
                              :class="[
                                { 'md-error': failed },
                                { 'md-valid': passed }
                              ]"
                            >
                              <div style="width: 100%">
                                <ckeditor
                                  @ready="onReady"
                                  :editor="editor"
                                  v-model="params.introduction"
                                  :config="editorConfig"
                                ></ckeditor>
                              </div>

                              <slide-y-down-transition>
                                <md-icon class="error" v-show="failed"
                                  >close
                                </md-icon>
                              </slide-y-down-transition>
                              <slide-y-down-transition>
                                <md-icon class="success" v-show="passed"
                                  >done
                                </md-icon>
                              </slide-y-down-transition>
                            </md-field>
                            <div class="validate-error">
                              {{ errors[0] }}
                            </div>
                          </ValidationProvider>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </md-card-content>

            <md-card-actions class="text-center">
              <md-button type="submit" class="md-success"
                >{{ $t("common.save") }}
              </md-button>
              <md-button native-type="button" @click="cancel"
                >{{ $t("common.cancel") }}
              </md-button>
            </md-card-actions>
          </md-card>
        </form>
      </ValidationObserver>
    </div>
    <!--  Avatar  -->
    <crop-upload-image-modal
      :modal-data="modalAvatar"
      :origin-img-src="imageCircle"
      :min-container-width="340"
      :min-container-height="260"
      :background="true"
      :rotatable="false"
      :img-style="{ width: '320px', height: '220px' }"
      :aspect-ratio="1"
      :auto-crop-area="1"
      :click-outside-to-close="false"
      @closeModal="closeModalChangeAvatar"
      @setCroppedImageSrc="updateAvatar"
    ></crop-upload-image-modal>

    <!--   Cover -->
    <crop-upload-image-modal
      :modal-data="modalCover"
      :origin-img-src="coverImageCircle"
      :min-container-width="320"
      :min-container-height="180"
      :background="true"
      :rotatable="false"
      :img-style="{ width: '320px', height: '180px' }"
      :aspect-ratio="16 / 9"
      :auto-crop-area="1"
      :click-outside-to-close="false"
      @closeModal="closeModalChangeCover"
      @setCroppedImageSrc="updateCover"
    ></crop-upload-image-modal>
  </div>
</template>

<script>
import sanitizer from "sanitizer";
import { ProgramService } from "../../services/program.service";
import DecoupledEditor from "@ckeditor/ckeditor5-build-decoupled-document";
import CkeditorUploadAdapter from "@/helpers/ckeditor-upload-adapter";
import queryHelper from "@/helpers/query-helper";
import { ProgramTypeService } from "../../services/programType.service";
import { ProgramDivisionService } from "../../services/programDivision.service";
import { NationService } from "../../services/nation.service";
import { ProgramTemplateService } from "../../services/programTemplate.service";
import { mapGetters, mapMutations } from "vuex";
import CropUploadImageModal from "../../components/VueUploadMultipleImage/CropUploadImageModal";

export default {
  name: "ProgramCreateForm",
  components: { CropUploadImageModal },
  props: {
    id: {},
    editMode: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      video: null,
      avatarImg: "../img/image_placeholder.jpg",
      modalAvatar: {
        show: false,
        action: "create"
      },
      modalCover: {
        show: false,
        action: "create"
      },
      imageCircle: "",
      coverImageCircle: "",
      formTitle: this.$t("page_title.program_create"),
      params: {
        code: null,
        name: null,
        vi_name: null,
        program_division_id: null,
        program_type_id: null,
        is_public: true,
        cover_image: null,
        avatar: null,
        introduction: null,
        url: null,
        university_address: null,
        video: null,
        country_alpha_two_code: null,
        country_alpha_three_code: null,
        staff_full_time: null,
        staff_part_time: null,
        master_percent: null,
        doctoral_percent: null,
        faculty_scale: null,
        program_scale: null,
        university_name: null,
        university_vi_name: null,
        faculty_vi_name: null,
        faculty_name: null
      },
      nationOptions: [],
      programTypeOptions: [],
      programDivisionOptions: [],
      programTemplateOptions: [],
      programOptions: [],
      editor: DecoupledEditor,
      editorConfig: {
        fontSize: {
          options: [
            8,
            9,
            10,
            11,
            12,
            13,
            "default",
            15,
            16,
            17,
            18,
            19,
            20,
            21,
            22,
            24,
            26,
            28,
            36,
            48
          ],
          supportAllValues: true
        },
        extraPlugins: [this.uploader],
        language: "vi"
      }
    };
  },
  mounted() {
    if (this.editMode) {
      this.getDetailProgram(this.id);
    }
    this.getProgramTemplateOptions();
    this.getProgramTypeOptions();
    this.getProgramDivisionOptions();
    this.getProgram();
    this.getNationOptions();
  },
  methods: {
    ...mapMutations({
      setNationOptions: "SET_NATION_OPTIONS"
    }),
    onReady(editor) {
      // Insert the toolbar before the editable area.
      editor.ui
        .getEditableElement()
        .parentElement.insertBefore(
          editor.ui.view.toolbar.element,
          editor.ui.getEditableElement()
        );
    },
    async getDetailProgram(id) {
      const info = await new ProgramService().getById(id);
      this.params.code = info.code;
      this.params.name = info.name;
      this.params.vi_name = info.vi_name;
      this.params.program_division_id = info.program_division_id;
      this.params.program_type_id = info.program_type_id;
      this.params.is_public = info.is_public;
      this.params.url = info.url;
      this.params.university_address = info.university_address;
      this.params.video = info.video;
      this.params.introduction = info.introduction;
      this.params.country_alpha_two_code = info.country_alpha_two_code;
      this.params.country_alpha_three_code = info.country_alpha_three_code;
      this.params.staff_full_time = info.staff_full_time;
      this.params.staff_part_time = info.staff_part_time;
      this.params.master_percent = info.master_percent;
      this.params.doctoral_percent = info.doctoral_percent;
      this.params.faculty_scale = info.faculty_scale;
      this.params.program_scale = info.program_scale;
      this.params.university_name = info.university_name;
      this.params.university_vi_name = info.university_vi_name;
      this.params.faculty_vi_name = info.faculty_vi_name;
      this.params.faculty_name = info.faculty_name;
      this.params.avatar = info.avatar;
      this.params.cover_image = info.cover_image;
      // this.video = info.video;

      //  get avatar image
      if (info.avatar !== null && info.avatar !== "") {
        this.imageCircle = info.avatar;
      }

      //get cover image
      if (info.cover_image !== null && info.cover_image !== "") {
        this.coverImageCircle = info.cover_image;
      }
    },
    changeCoverImg(coverImage) {
      if (coverImage) {
        this.params.cover_image = coverImage[0];
      }
    },
    // changeVideo(video) {
    //   if (video) {
    //     this.params.video = video[0];
    //   }
    // },
    async getNationOptions() {
      if (this.storeNationsOptions && this.storeNationsOptions.length > 0) {
        this.nationOptions = this.storeNationsOptions;
        return;
      }
      const response = new NationService().getListPublic();
      let nations = response.data;
      let nationOptions = [];
      nations.forEach(nation => {
        nationOptions.push({
          id: nation.alpha2Code,
          text: nation.name,
          country_alpha_three_code: nation.alpha3Code
        });
      });
      this.nationOptions = nationOptions;
      this.setNationOptions(nationOptions);
    },
    async getProgramTemplateOptions() {
      const response = await new ProgramTemplateService().getList({
        limit: 1000
      });
      this.programTemplateOptions = response.data;
      return response.data;
    },
    async getProgramTypeOptions() {
      const response = await new ProgramTypeService().getList({
        limit: 1000
      });
      this.programTypeOptions = response.data;
      return response.data;
    },
    async getProgramDivisionOptions() {
      const response = await new ProgramDivisionService().getList({
        limit: 1000
      });
      this.programDivisionOptions = response.data;
      return response.data;
    },
    async getProgram() {
      const response = await new ProgramService().getList({
        limit: 1000
      });
      let programs = response.data;
      let programOptions = [];
      programs.forEach(program => {
        if (parseInt(program.id) !== parseInt(this.id)) {
          programOptions.push({
            id: program.id,
            text: program.name
          });
        }
      });
      this.programOptions = programOptions;
    },
    cancel() {
      this.$router.push({ name: "ProgramList" });
    },
    async submit() {
      let formData = this.buildFormDataCreateProgram();
      if (this.editMode) {
        await this.updateProgram(this.id, formData);
        return;
      }
      await this.createProgram(formData);
    },
    async createProgram(formData) {
      const response = await new ProgramService().create(formData);
      if (!response) return;
      this.$notify({
        title: this.$t("common.created"),
        text: this.$t("common.created_text", {
          name: this.$t("program.title"),
          value: sanitizer.escape(response.name)
        }),
        type: "success"
      });
      setTimeout(() => this.$router.push({ name: "ProgramList" }), 500);
    },
    async updateProgram(id, formData) {
      const response = await new ProgramService().update(id, formData);
      if (!response) return;
      this.$notify({
        title: this.$t("common.updated"),
        text: this.$t("common.updated_text", {
          name: this.$t("program.title"),
          value: sanitizer.escape(response.name)
        }),
        type: "success"
      });
    },
    buildFormDataCreateProgram() {
      let params = this.params;
      if (params.country_alpha_two_code) {
        const nation = this.nationOptions.find(
          ({ id }) => id == params.country_alpha_two_code
        );
        if (nation) {
          params.country_alpha_three_code = nation.country_alpha_three_code;
        }
      }
      if (this.editMode) {
        params._method = "PUT";
      }
      return queryHelper.buildFormData(params);
    },
    uploader(editor) {
      editor.plugins.get("FileRepository").createUploadAdapter = loader => {
        return new CkeditorUploadAdapter(loader);
      };
    },
    closeModalChangeAvatar() {
      this.modalAvatar.show = false;
      this.$store.commit("DESTROY_MODAL");
    },
    showModalChangeAvatar(action) {
      this.modalAvatar.action = action || "create";
      this.modalAvatar.show = true;
      this.$store.commit("SHOW_MODAL");
    },
    onFileChange(e) {
      this.showModalChangeAvatar("edit");
    },
    updateAvatar(file) {
      this.params.avatar = file;
      this.createImage(file, "circle");
    },
    createImage(file, type) {
      let reader = new FileReader();
      let vm = this;

      reader.onload = e => {
        if (type === "circle") {
          vm.imageCircle = e.target.result;
        }
      };
      reader.readAsDataURL(file);
    },
    closeModalChangeCover() {
      this.modalCover.show = false;
      this.$store.commit("DESTROY_MODAL");
    },
    showModalChangeCover(action) {
      this.modalCover.action = action || "create";
      this.modalCover.show = true;
      this.$store.commit("SHOW_MODAL");
    },
    onFileChangeCover(e) {
      this.showModalChangeCover("edit");
    },
    updateCover(file) {
      this.params.cover_image = file;
      this.createCoverImg(file, "circle");
    },
    createCoverImg(file, type) {
      let reader = new FileReader();
      let vm = this;

      reader.onload = e => {
        if (type === "circle") {
          vm.coverImageCircle = e.target.result;
        }
      };
      reader.readAsDataURL(file);
    }
  },
  watch: {
    id(newVal) {
      this.getDetailProgram(newVal);
    }
  },
  computed: {
    ...mapGetters({ storeNationsOptions: "nationsOptions" })
  }
};
</script>

<style scoped lang="scss">
.md-card .md-card-actions {
  border: none;
}

.text-center {
  justify-content: center !important;
}

.md-field .success.md-icon,
.md-field .error.md-icon {
  right: -20px;
}

.image-fix-container {
  max-width: 250px;
  overflow: hidden;
  margin: 0 auto;
  margin-bottom: 10px;
  box-shadow: 0 10px 30px -12px rgb(0 0 0 / 42%), 0 4px 25px 0 rgb(0 0 0 / 12%),
    0 8px 10px -5px rgb(0 0 0 / 20%);
}

.content-button {
  margin: 0;
}

.management-uni-rating-container {
  text-align: right;
  margin: 10px 40px;
}

.management-uni-rating-container a {
  display: inline-block;
  text-align: center;
}

.management-uni-rating-container a:hover {
  cursor: pointer;
}

.management-uni-rating-container a i {
  padding: 10px;
  font-size: 16px;
  background: #9c27b0;
  border-radius: 10px;
}

.management-uni-rating-container a i.fa-pen:before {
  color: #ffffff;
}

.edit-btn {
  background: #9c27b0;
  color: #ffffff !important;
  font-size: 18px;
  border-radius: 8px;
  padding: 10px 10px;
  font-weight: 500;
}

.uni-count-container {
  h4 {
    margin: 10px 0 0;
    max-width: 320px;
    background: #4caf50;
    border-radius: 2px;
    padding: 5px;
    color: #ffffff;
    font-weight: 500;
    text-align: center;
  }
}

#uni-avatar {
  margin-bottom: 30px;
}

#uni-cover {
  margin-bottom: 30px;
  .file-input.img-circle {
    max-width: 250px;
  }
  .image-fix-container {
    max-width: 250px;
  }
}
</style>
